import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import {useTranslation} from "react-i18next";

function KitchenPage() {
    const { t } = useTranslation();
    const directory= "/images/kouzina/";
    const filenames=[
        'VPR02373_Vasso_Paraschi.webp',
        'VPR02526_Vasso_Paraschi.webp',
        'VPR02532_Vasso_Paraschi.webp',
        'VPR02532_Vasso_Paraschi.webp',
        'VPR02699_Vasso_Paraschi.webp',
        'VPR02855-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR02910_Vasso_Paraschi.webp',
        'VPR02928_Vasso_Paraschi.webp',
        'VPR03089_Vasso_Paraschi.webp',
        'VPR03447_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Kitchens")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>

        </div>
    );
}

export default KitchenPage;
